// The chat widget comes from the manufacturer's chat snippet, so we don't
// know the provider. Its elements can't be hidden with CSS either (Tawk sets
// inline !important styles), so this calls the provider's own API instead.

interface TawkApi {
    hideWidget?: () => void;
    showWidget?: () => void;
    onLoad?: () => void;
    cbcOnLoadHooked?: boolean;
}

export interface ChatWindow {
    Tawk_API?: TawkApi;
    Intercom?: (command: string, options?: object) => void;
    $crisp?: unknown[][];
    zE?: (widget: string, command: string) => void;
    fcWidget?: {hide?: () => void; show?: () => void};
    tidioChatApi?: {hide?: () => void; show?: () => void};
}

let chatHidden = false;

const applyTawk = (win: ChatWindow) => {
    // the snippet keeps an existing Tawk_API (`Tawk_API || {}`), so this also
    // works when the snippet has not been injected yet
    const tawk = (win.Tawk_API = win.Tawk_API || {});

    if (!tawk.cbcOnLoadHooked) {
        tawk.cbcOnLoadHooked = true;
        const previousOnLoad = tawk.onLoad;

        tawk.onLoad = () => {
            previousOnLoad?.();
            if (chatHidden) tawk.hideWidget?.();
        };
    }

    if (typeof tawk.hideWidget === 'function') {
        if (chatHidden) {
            tawk.hideWidget();
        } else {
            tawk.showWidget?.();
        }
    }
};

export const setChatWidgetHidden = (
    hidden: boolean,
    win: ChatWindow = window as unknown as ChatWindow
) => {
    chatHidden = hidden;

    applyTawk(win);
    const intercom = win.Intercom;
    intercom?.('update', {hide_default_launcher: hidden});
    win.$crisp?.push(['do', hidden ? 'chat:hide' : 'chat:show']);
    win.zE?.('messenger', hidden ? 'hide' : 'show');

    if (hidden) {
        win.fcWidget?.hide?.();
        win.tidioChatApi?.hide?.();
    } else {
        win.fcWidget?.show?.();
        win.tidioChatApi?.show?.();
    }
};
